// IMPORTANT: Keep these IDs synced with the 'layer.___' keys in the i18n json files

/* Mosaic V3 layers */

// Soil Tests
export const SOIL_TESTS = 'soil.sample';

// Prescription Maps
export const PRESCRIPTION = 'rx';
export const PRESCRIPTION_TYPES = {
  PLANTING: 'planting',
  FERTILITY: 'fertility-pre-plant',
};

// Imported Shapefiles
export const IMPORTED_SHAPEFILE = 'imported-map';
export const IMPORTED_SHAPEFILE_TYPES = {
  PRESCRIPTION: 'application/vnd.climate.rx.planting.shp',
  ZONES: 'application/vnd.climate.zones.shp',
};

// FHA
export const FHA = {
  RAW: 'fha.raw',
  SCOUTING: 'fha.rank',
  TRUE_COLOR: 'fha.true-color',
  VEGETATION: 'fha.abs',
};

export const FHA_IDS = Object.values(FHA);
export const FHA_KEY = 'fha';

// Other (Non-Satellite) Imagery
export const OTHER_IMAGERY = 'otherImagery';
export const OTHER_IMAGERY_TYPES = {
  CCI: 'nonsat.imagery.cci',
  CHLOROPHYLL: 'nonsat.imagery.chlorophyll',
  ELEVATION: 'nonsat.imagery.elevation',
  IMPORTED: 'nonsat.imagery.imported',
  NDVI: 'nonsat.imagery.ndvi',
  RGB: 'nonsat.imagery.rgb',
  THERMAL: 'nonsat.imagery.thermal',
  WATERSTRESS: 'nonsat.imagery.waterstress',
};
export const OTHER_IMAGERY_IDS = Object.values(OTHER_IMAGERY_TYPES);

// Crop Water Use Map Layer.
export const CROP_WATER = 'cropwateruse';
export const CROP_WATER_KEY = CROP_WATER;

export const MOSAIC_V3_IDS = [
  FHA.SCOUTING,
  FHA.VEGETATION,
  FHA.TRUE_COLOR,
  IMPORTED_SHAPEFILE,
  ...OTHER_IMAGERY_IDS,
  CROP_WATER,
];

export const SEASON_SPECIFIC_MOSAIC_V3_IDS = [
  { key: FHA_KEY, ids: [FHA.SCOUTING, FHA.VEGETATION, FHA.TRUE_COLOR] },
  { key: PRESCRIPTION, ids: [PRESCRIPTION] },
  { key: CROP_WATER_KEY, ids: [CROP_WATER] },
];
export const SEASON_AGNOSTIC_MOSAIC_V3_IDS = [
  { key: SOIL_TESTS, ids: [SOIL_TESTS] },
  { key: IMPORTED_SHAPEFILE, ids: [IMPORTED_SHAPEFILE] },
  { key: OTHER_IMAGERY, ids: OTHER_IMAGERY_IDS },
];

/* FVP Map Layers */

/* Prescriptions */
export const SCRIPTS = {
  PLANTING_SCRIPT: 'plantingScripts',
  APPLICATION_SCRIPT: 'applicationScripts',
  FERTILITY_SCRIPT: 'fertilityScripts',
};

// Field Summary
export const FIELD_SUMMARY = 'fieldsummary';

// Field Summary Past Weather
export const WEATHER = 'weather';

// Planting
export const PLANTING_CATEGORY = 'planting-category';
export const PRECISION_PLANTING_SUB_LAYERS = {
  APPLIED_DOWN_FORCE: 'applieddownforce',
  CEC: 'cec',
  CLEAN_FURROW: 'cleanfurrow',
  DOWN_FORCE: 'downforce',
  FURROW_MOISTURE: 'furrowmoisture',
  ORGANIC_MATTER: 'organicmatter',
  SINGULATION: 'singulation',
  SOIL_TEMPERATURE: 'soiltemperature',
  SPACING: 'spacing',
  UNIFORM_FURROW: 'uniformfurrow',
};

export const PLANTING = {
  HYBRID: 'hybrid',
  POPULATION: 'actualpopulation',
  DATE: 'plantingdate',
  PLANTER_SPEED: 'planterspeed',
  ...PRECISION_PLANTING_SUB_LAYERS,
  TARGET_POPULATION: 'targetpopulation',
  PLANTING_SCRIPT: SCRIPTS.PLANTING_SCRIPT,
};
export const PLANTING_IDS = Object.values(PLANTING);
export const PLANTING_HYBRID_DEFAULT = 'hybrid-variety';

// Harvest
export const HARVEST_CATEGORY = 'harvest-category';
export const HARVEST = {
  YIELD: 'yield',
  MOISTURE: 'moisture',
  DATE: 'harvestdate',
  COMBINE_SPEED: 'combinespeed',
};
export const HARVEST_IDS = Object.values(HARVEST);

// In Season
export const IN_SEASON_CATEGORY = 'in-season-category';
export const IN_SEASON = {
  FHA: FHA_KEY,
  APPLICATIONS: 'applicationrate',
  OTHER_IMAGERY,
  IMPORTED_SHAPEFILE,
  CROP_WATER,
  APPLICATION_SCRIPT: SCRIPTS.APPLICATION_SCRIPT,
  FERTILITY_SCRIPT: SCRIPTS.FERTILITY_SCRIPT,
};
export const IN_SEASON_IDS = Object.values(IN_SEASON);

export const BASE_LAYERS_CATEGORY = 'base-layers-category';
// Base Layers
export const BASE_LAYERS = {
  // TODO: Add this ID back when soil tests map layer is added
  PLANTER_ELEVATION: 'elevation',
  COMBINE_ELEVATION: 'combineelevation',
  SOIL_SSURGO: 'soilssurgo',
  DRAINAGE: 'drainage',
  SOIL_TYPE: 'soilType',
};
export const BASE_LAYER_IDS = Object.values(BASE_LAYERS);

export const SOILSURGO_LAYERS = [
  BASE_LAYERS.SOIL_SSURGO,
  BASE_LAYERS.DRAINAGE,
  BASE_LAYERS.SOIL_TYPE,
];

/* All Season-Agnostic Map Layer IDs */
export const SEASON_AGNOSTIC_IDS = [
  BASE_LAYERS.SOIL_SSURGO,
  OTHER_IMAGERY,
  IMPORTED_SHAPEFILE,
  ...SEASON_AGNOSTIC_MOSAIC_V3_IDS,
];

export const SOIL_MAP = 'SoilMap';

/* FieldViewSpatialDisplay asset feature enables */
export const FIELD_VIEW_SPATIAL_DISPLAY_LAYERS = Object.fromEntries([
  ...Object.values(PLANTING),
  ...Object.values(HARVEST),
  IN_SEASON.APPLICATIONS,
  BASE_LAYERS.COMBINE_ELEVATION,
  BASE_LAYERS.PLANTER_ELEVATION
].map((id) => [id, true]));
